import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';

export interface OnboardingWelcomeSettings {
  active: boolean;
  video_url_premium: string | null;
  video_url_standard: string | null;
}

@Injectable({ providedIn: 'root' })
export class OnboardingWelcomeSettingsService {
  private apiService = inject(ApiService);

  getSettings(): Observable<OnboardingWelcomeSettings> {
    return this.apiService.request<OnboardingWelcomeSettings>('GET', 'onboarding-welcome-settings');
  }
}
